// extracted by mini-css-extract-plugin
export default {"staticCollapse":"StaticCollapse_staticCollapse__B3M3P","isOpen":"StaticCollapse_isOpen__W4sBJ"};